function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
const SVGKeyframeId = 'klarna-loader-animation-svg';
const CircleKeyframeId = 'klarna-loader-animation-circle';
const getPostFix = ({ small, large })=>small && 'small' || large && 'large' || 'default';
const getStrokeDashOffset = (outerDiameter)=>({
        strokeDashoffsetMin: 75 * outerDiameter / 100,
        strokeDashoffsetMax: 280 * outerDiameter / 100
    });
const loaderSizes = {
    small: 12,
    large: 100,
    default: 20
};
export const getKeyframes = (sizeProps)=>{
    const sizeName = getPostFix(sizeProps);
    const outerDiameter = loaderSizes[sizeName];
    const { strokeDashoffsetMax, strokeDashoffsetMin } = getStrokeDashOffset(outerDiameter);
    return `
    @keyframes ${SVGKeyframeId}-${sizeName} {
      0% {
        transform: rotateZ(0deg);
      }
      100% {
        transform: rotateZ(360deg);
      }
    }

    @keyframes ${CircleKeyframeId}-${sizeName} {
      0%,
      25% {
        stroke-dashoffset: ${strokeDashoffsetMax};
        transform: rotate(0);
      }
      50%,
      75% {
        stroke-dashoffset: ${strokeDashoffsetMin};
        transform: rotate(45deg);
      }
      100% {
        stroke-dashoffset: ${strokeDashoffsetMax};
        transform: rotate(360deg);
      }
    }
  `.replace(/ {2}|\n/g, '');
};
export const getDefaultStyleSheet = ({ inverted, large, small, theme })=>{
    var _theme_colors_light, _theme_colors_light1;
    const postFix = getPostFix({
        large,
        small
    });
    const outerDiameter = loaderSizes[postFix];
    const outerRadius = outerDiameter / 2;
    const strokeWidth = small === true ? 2.5 : large === true ? 7.5 : 2;
    const innerRadius = outerRadius - strokeWidth / 2;
    const strokeDasharray = 2 * Math.PI * innerRadius;
    const { strokeDashoffsetMin } = getStrokeDashOffset(outerDiameter);
    return {
        svgAttrs: {
            viewBox: `0 0 ${outerDiameter} ${outerDiameter}`
        },
        svgStyle: _object_spread({
            width: outerDiameter,
            height: outerDiameter
        }, {
            animation: `${SVGKeyframeId}-${postFix} 2s linear infinite`
        }),
        circleAttrs: {
            cx: outerRadius,
            cy: outerRadius,
            r: innerRadius
        },
        circleStyle: _object_spread({
            display: 'block',
            fill: 'transparent',
            stroke: inverted ? (_theme_colors_light = theme.colors.light) === null || _theme_colors_light === void 0 ? void 0 : _theme_colors_light.textStates.inverse.default : (_theme_colors_light1 = theme.colors.light) === null || _theme_colors_light1 === void 0 ? void 0 : _theme_colors_light1.textStates.default.default,
            strokeLinecap: 'square',
            strokeDasharray,
            strokeDashoffset: strokeDashoffsetMin,
            strokeWidth,
            transformOrigin: '50% 50%'
        }, {
            animation: `${CircleKeyframeId}-${postFix} 1.4s ease-in-out infinite both`
        })
    };
};
